// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { isTextWrap } from "@rugby/XDL/Utilities/utilities";
import ReactDOM from "react-dom";

const canUseDOM = () => {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
const createUniversalPortal = (children: any, selector = "body") => {
    if (!canUseDOM()) {
        return null;
    }
    return ReactDOM.createPortal(children, document.querySelector(selector)!);
};

const xngCalculateTooltipPosition = (tooltipInst: any, anchorElement: any, boundariesElement?: any) => {
    let menuWidth = tooltipInst.offsetWidth;
    const offset = tooltipInst.className?.includes("recentlyPurchased-menu")
        ? window && window.innerWidth > 1300
            ? 60
            : 20
        : 0;

    boundariesElement = boundariesElement || tooltipInst.parentElement;
    const { bottom: anchorBottom, left: anchorLeft } = anchorElement.getBoundingClientRect();
    const { right: boundariesRight } = boundariesElement.getBoundingClientRect();
    if (menuWidth > boundariesElement.clientWidth) {
        menuWidth = boundariesElement.clientWidth;
    }

    let left = anchorLeft + menuWidth;
    const top = anchorBottom + (!isMobile() && isTextWrap(anchorElement.getElementsByTagName("p")[0]) ? 15 : 0);

    if (left > boundariesRight) {
        left = anchorLeft - (left - boundariesRight);
        return {
            top: `${top}px`,
            left: `${left - offset}px`,
            right: "auto",
            maxWidth: `${boundariesElement.clientWidth}px`,
            arrowLeft: `${anchorLeft + offset - left + anchorElement.offsetWidth / 4}px`,
            opacity: 1,
        };
    }

    return {
        top: `${top}px`,
        left: `${anchorLeft}px`,
        right: "auto",
        maxWidth: `${boundariesElement.clientWidth}px`,
        arrowLeft: `${anchorElement.offsetWidth / 4}px`,
        opacity: 1,
    };
};

const isMobile = () => window && window.matchMedia("(max-width: 768px) and (hover: none)").matches;

export { canUseDOM, createUniversalPortal, xngCalculateTooltipPosition, isMobile };
